export enum DwUserActivityTypes {
	ChangeRoute = 'change_route',
	DownloadData = 'download_data',
	ReturnForExecution = 'return_for_execution',
	ConfirmExecution = 'confirm_execution',
	CancelExecution = 'cancel_execution',
	DownloadChart = 'download_chart',
	UploadProductsSizes = 'upload_products_sizes',
	Update = 'update',
	Compression = 'compression',
	DownloadProductLayout = 'download_product_layout',
	Revert = 'restoring',
	Edit = 'sm_edit',
	Copy = 'sm_copy',
	Delete = 'sm_delete',
	Create = 'sm_create',
	Upload = 'upload_data',
	ProductRotation = 'product_rotation',
	DownloadCompletion = 'download_completion',
	ReportView = 'report_view',
	SendToExecution = 'send_to_execution',
	ExecutionDone = 'execution_done'
}